<div class="ctr">
  <div class="overlay">
    <div class="arrow"><img src="../../../../assets/images/white-down.png" /></div>
  </div>
  <div class="copy" [innerHTML]="pageComponent?.statContent">
  </div>
</div>
